export default "<ng-container *ngTemplateOutlet=\"template; context: {\n  message: message,\n  chatKey: chatKey\n}\"></ng-container>\n"